/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Studio_LocationInputs */

const en_home_studio_location = /** @type {(inputs: Home_Studio_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Based in Liepāja, Latvia.`)
};

const lv_home_studio_location = /** @type {(inputs: Home_Studio_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrodamies Liepājā, Latvijā.`)
};

/**
* | output |
* | --- |
* | "Based in Liepāja, Latvia." |
*
* @param {Home_Studio_LocationInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_studio_location = /** @type {((inputs?: Home_Studio_LocationInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Studio_LocationInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_studio_location(inputs)
	return en_home_studio_location(inputs)
});